import Typography, { TypographyProps } from '@mui/material/Typography';
import Link, { LinkProps } from '@mui/material/Link';
import Box from '@mui/material/Box';

export const Heading = ({
    children,
    ...props
}: { children: React.ReactNode } & TypographyProps) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                mb: 2,
            }}
        >
            <Typography
                variant="h4"
                color="text.primary"
                {...props}
                sx={{
                    fontSize: '1.125rem',
                    fontWeight: 800,
                    ...props.sx,
                }}
            >
                {children}
            </Typography>
        </Box>
    );
};

export const TextLink = ({
    children,
    ...props
}: { children: React.ReactNode } & TypographyProps & LinkProps) => {
    return (
        <Link
            variant="body1"
            {...props}
            sx={{
                'color': '#202024',
                'cursor': 'pointer',
                'width': 'fit-content',
                'margin': '0 0 0 auto',
                'textAlign': 'right',
                'textDecoration': 'underline',
                'textDecorationColor': '#6E6E71',
                '&:hover': {
                    textDecorationColor: '#202024',
                },
                ...props.sx,
            }}
        >
            {children}
        </Link>
    );
};
